import BaseProxy from './base-proxy';

/**
 * Class PTokenProxy
 */

const API_CONNECT_USB = 'http://localhost:32318/api/ca';

class PTokenProxy extends BaseProxy {
  /**
   * Constructor.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('/e-invoice-api/api/ca-sign', parameters);
  }

  testConnectionUsb() {
    return this.submit('get', `${API_CONNECT_USB}/test-connection/current`, null, { timeout: 2000, allowToast: false, showResponseStatus: true });
  }

  currentUsbInfo() {
    return this.submit('get', `${API_CONNECT_USB}/current-usb-info`, null, { timeout: 3000, allowToast: false, showResponseStatus: true });
  }

  signXml(payload) {
    return this.submit('post', `${API_CONNECT_USB}/sign-xml/current`, payload, { allowToast: false, responseType: 'blob' });
  }

  signPdf(payload) {
    return this.submit('post', `${API_CONNECT_USB}/sign-pdf/current`, payload, { allowToast: false, responseType: 'blob' });
  }
}

export default PTokenProxy;



// WEBPACK FOOTER //
// ./src/store/proxies/p-token-proxy.js